import React, { useState, useRef, useCallback, useEffect } from 'react';
import {
  HoverStyles,
  Text,
  TextButton,
  TextButtonPriority,
} from '@wix/wix-ui-tpa/cssVars';
import { st, classes } from './Collapsible.st.css';
import { useBi, useEnvironment } from '@wix/yoshi-flow-editor';
import { uoUWidgetIntentClickOnLiveSiteSrc187Evid10 } from '@wix/bi-logger-bookings-data/v2';
import { BI_WIDGET_NAME } from '../../../../../../consts';

export interface CollapsibleProps {
  children: React.ReactNode;
  showMoreLabel: string;
  showLessLabel: string;
  className?: string;
  contentRef?: React.RefObject<HTMLDivElement>;
}

export const Collapsible: React.FC<CollapsibleProps> = ({
  children,
  showMoreLabel,
  showLessLabel,
  className,
  contentRef,
}) => {
  const [expanded, setExpanded] = useState(false);
  const [showToggleButton, setShowToggleButton] = useState(true);
  const collapsibleAreatRef = useRef<HTMLDivElement>(null);
  const bi = useBi();
  const environment = useEnvironment();
  const onClick = () => {
    bi?.report(
      uoUWidgetIntentClickOnLiveSiteSrc187Evid10({
        widgetName: BI_WIDGET_NAME,
        action: expanded ? 'collapse' : 'expand',
        environment: JSON.stringify(environment),
      }),
    );
    setExpanded((v) => !v);
  };

  useEffect(() => {
    if (
      contentRef?.current?.clientHeight &&
      collapsibleAreatRef.current?.clientHeight
    ) {
      setShowToggleButton(
        contentRef?.current?.clientHeight >
          collapsibleAreatRef.current?.clientHeight,
      );
    }
  }, [contentRef]);
  return (
    <div className={st(classes.root, className)}>
      <div
        ref={collapsibleAreatRef}
        className={st(classes.content, { expanded })}
        data-hook="collapsible-content"
        id="collapsible-content"
      >
        {children}
      </div>

      {showToggleButton && (
        <TextButton
          contentClassName={classes.toggleButtonText}
          className={classes.toggleButton}
          onClick={onClick}
          priority={TextButtonPriority.link}
          data-hook="collapsible-toggle"
          aria-expanded={expanded}
          aria-controls="collapsible-content"
        >
          {expanded ? showLessLabel : showMoreLabel}
        </TextButton>
      )}
    </div>
  );
};
